import React, { useContext } from "react";
import "./Trusted_content.css";
import { Context } from "../../../utils/context";

function Trusted_content() {
  const { language } = useContext(Context);

  return (
    <>
      <section className="Trusted_content">
        <div className="container">
          <div className="heading_holder">
            <h4>
              <span> {language == 1 ? "Trusted" : "Fiable"} </span> &nbsp;
              {language == 1
                ? "by Global Universities and Leading Institutions"
                : "par des universités mondiales et des institutions de premier plan"}
            </h4>
            <p>
              {language == 1
                ? "Our global partner network connects students to opportunities across"
                : "Notre réseau mondial de partenaires connecte les étudiants à des opportunités à travers"}
              <span className="bold_text">
                {" "}
                {language == 1
                  ? "France, the USA, Australia, New Zealand"
                  : "France, les États-Unis, l’Australie, la Nouvelle-Zélande"}{" "}
              </span>{" "}
              &{" "}
              <span className="bold_text">
                {language == 1 ? "Georgia" : "Géorgie"}
              </span>
              .
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Trusted_content;
